var React = require('react');

function Rookie (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:none;stroke:#000;stroke-linecap:square;stroke-linejoin:bevel;stroke-width:2px;}")),React.createElement("title",{"key":1},"Rookie Ship"),React.createElement("path",{"id":"path926","className":"cls-1","d":"M34,77.55l30-30,30,30","key":2})]);
}

Rookie.defaultProps = {"id":"svg8","viewBox":"0 0 128 128"};

module.exports = Rookie;

Rookie.default = Rookie;
